export default "__VITE_ASSET__CBBdRAZg__"